<div class="d-flex flex-column h-100">
  <ziro-top-nav></ziro-top-nav>

  <div class="flex-grow-1 overflow-auto">
    <router-outlet></router-outlet>
  </div>

  <ziro-bottom-nav></ziro-bottom-nav>
</div>
